var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 22.7857H25.5V24.5H0.5V22.7857ZM22.8214 8.21404C23.0582 8.21404 23.2853 8.12373 23.4528 7.96298C23.6202 7.80224 23.7143 7.58421 23.7143 7.35688V4.78541C23.7142 4.60926 23.6576 4.4374 23.5522 4.29323C23.4467 4.14906 23.2976 4.03958 23.125 3.97969L13.3036 0.551065C13.1074 0.482978 12.8926 0.482978 12.6964 0.551065L2.875 3.97969C2.70244 4.03958 2.55329 4.14906 2.44785 4.29323C2.3424 4.4374 2.28579 4.60926 2.28571 4.78541V7.35688C2.28571 7.58421 2.37978 7.80224 2.54723 7.96298C2.71467 8.12373 2.94177 8.21404 3.17857 8.21404H4.07143V19.3571H2.28571V21.0714H23.7143V19.3571H21.9286V8.21404H22.8214ZM4.07143 5.38542L13 2.26538L21.9286 5.38542V6.49973H4.07143V5.38542ZM14.7857 19.3571H11.2143V8.21404H14.7857V19.3571ZM5.85714 8.21404H9.42857V19.3571H5.85714V8.21404ZM20.1429 19.3571H16.5714V8.21404H20.1429V19.3571Z",
    fill: "#222F3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.5c7762230297ebc9e4c0203bf33a07cb.svg";
export { ForwardRef as ReactComponent };